"use client"

import * as React from 'react';
import Image from "next/image";

export default function Item (data) {

    return <div className="minicart-body-content-item">
        <div className="product-header">
            <div className="product-title">
                <strong>{data.item.product_name}</strong>
            </div>
            <div className="product-type">

            </div>
        </div>
        <div className="product-body">
            <div className="item-image">
                <Image
                    width={data.item.images[0]?.width}
                    height={data.item.images[0]?.height}
                    src={data.item.images[0]?.url_file}
                    alt={data.item.product_name}
                    sizes="100vw"
                    quality={90}
                    priority={1}
                />
            </div>
        </div>
    </div>

}